export default __webpack_public_path__ + "static/media/img_area_80.58ef67cb.svg";